import React, { useState } from "react";
import apiClient from "../api";

const SeoDashboard = () => {
  const [name, setname] = useState("");
  const [propertyData, setPropertyData] = useState(null);

  const fectchSeoProperties = async (searchName) => {
    try {
      const response = await apiClient.post("seodata/seoproperty", {
        name: searchName,
      });
      const seoproperty = response.data;
      setPropertyData(seoproperty);
      console.log("Response:", seoproperty?.name || seoproperty);
    } catch (error) {
      console.error("No data Found", error);
      setPropertyData(null);
    }
  };

  const saveChanges = async () => {
    try {
      const response = await apiClient.put("seodata/updateseoproperty", {
        id: propertyData._id,
        metaTitle: propertyData.metaTitle,
        metaDescription: propertyData.metaDescription,
      });
      console.log("Update Response:", response.data);
      alert("SEO data updated successfully!");
    } catch (error) {
      console.error("Error updating SEO data:", error);
      alert("Failed to update SEO data.");
    }
  };

  const handleChange = (e) => {
    setname(e.target.value);
  };

  return (
    <>
      <div className="container mb-3">
        <div className="row">
          <div className="col-md-12">
            <h2 className="mt-4">SEO Dashboard</h2>
            {/* proeprty Search box start */}
            <div className="input-group mb-3 mt-3">
              <input
                type="text"
                value={name}
                className="form-control"
                onChange={handleChange}
                placeholder="Search Property by Name"
                aria-label="Search Property"
                aria-describedby="button-search"
              />
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => fectchSeoProperties(name)}
                id="button-search"
              >
                Search
              </button>
            </div>
            <div>
              {propertyData && (
                <>
                  <p>
                    Property Name: <strong>{propertyData.name}</strong>
                    Id: <strong>{propertyData._id}</strong>
                  </p>
                  <form action="">
                    <div className="mb-3">
                      <label htmlFor="metaTitle" className="form-label">
                        Meta Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="metaTitle"
                        value={propertyData.metaTitle || ""}
                        onChange={(e) =>
                          setPropertyData({
                            ...propertyData,
                            metaTitle: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="metaDescription" className="form-label">
                        Meta Description
                      </label>
                      <textarea
                        className="form-control"
                        id="metaDescription"
                        rows="3"
                        value={propertyData.metaDescription || ""}
                        onChange={(e) =>
                          setPropertyData({ 
                            ...propertyData,
                            metaDescription: e.target.value,
                          })
                        }
                      ></textarea>
                    </div>
                    <div className="mb-3">
                      <button
                        type="button"
                        onClick={saveChanges}
                        className="btn btn-primary"
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
            {/* proeprty Search box end */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SeoDashboard;
